module.exports = __webpack_public_path__ + "img/na.3ec4c036.svg";